<div id="languageReport" *ngIf="test">
  <div class="bg-color-white shadow-lg color-primary body-m">
    <!-- Portada -->
    <ct-cover-page-report [colors]="colors" [reportType]="reportType" [test]="test" [currentDate]="currentDate"></ct-cover-page-report>

    <!-- Header -->
    <div id="header" class="d-flex justify-content-between color-tertiary body-s mar-t-3">
      <div>{{ (test.candidate?.name)
        ? (test.candidate | initials)
        : test.candidate.randstadCandidate }} | {{ (test.invitationId != 0 ? test.invitationId : test.externalId) }} | I/01/SP</div>
      <div>{{ currentDate | date:'dd/MM/yyyy' }}</div>
    </div>

    <!-- Contenido del informe -->
    <div class="page">
      <h1 class="color-tertiary title-xl mar-b-3" [innerHtml]="'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.TITLE' | translate"></h1>
      <div class="title-s mar-b-3">{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.FINALSCORE' | translate }}:</div>
      <div id="cards" class="row mar-b-4 title-xs">
        <div class="col-4 pad-x-1">
          <div class="card bg-color-tertiary color-white h-100">
            <div class="card-body pad-1">
              <p>
                <span>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.SUCCESSTITLE1' | translate }}</span><br>
                <span class="color-senary">{{ test.result.score }}%</span><br>
                <span>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.SUCCESSTITLE2' | translate }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-4 pad-x-1">
          <div class="card bg-color-tertiary color-white h-100">
            <div class="card-body pad-1">
              <p>
                <span>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.LEVELACHIEVED' | translate }}</span><br>
                <span class="color-senary">{{ test.result.levelAchieved }} <span class="color-white">{{ 'COMMON.OF' | translate }}</span> {{ test.result.maxLevel }}</span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-4 pad-x-1">
          <div class="card bg-color-tertiary color-white h-100">
            <div class="card-body pad-1">
              <ng-container *ngIf="test.result.levelAchieved == 1 && test.levels[0]?.levelDetail.cutOffMark>= test.levels[0]?.score">
                <p>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.LEVELDIDNOTREACHED' | translate }}</p>
                <p class="color-senary">{{ test.levels[0]?.levelDetail.description }}</p>
              </ng-container>

              <ng-container *ngIf="test.levels[0]?.levelDetail.cutOffMark < test.levels[0]?.score">
                <p>
                  <span>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.YOURFINALSCORE' | translate }} </span>
                  <span>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.BELONGSGROUP1' | translate }} </span>
                  <span class="color-senary">{{ maxLevelApproved() }} </span>
                  <span>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.BELONGSGROUP2' | translate }}</span>
                </p>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <p class="mar-b-2">{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.LEVELCOMPLETED' | translate:{ a: test.result.timeSpent, b: test.result.completionPercentage } }}</p>

      
      <div class="mar-b-4">
        <ng-container *ngFor="let level of test.levels; index as i">
          <div class="row mar-b-1">
            <div class="col-3 align-content-end">{{ 'COMMON.LEVEL' | translate }} {{ level.levelDetail.description }}</div>
            <div class="col-3 align-content-end">{{ level.time | secondsTime }} {{ 'COMMON.OF' | translate }} {{ level.maxDuration | secondsTime }}</div>
            <div class="col-4">
              <div class="mar-b-1" *ngIf="i == 0">{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.COMPLETION' | translate }}</div>
              <div class="d-inline-block w-75" style="vertical-align: middle;">
                <ngb-progressbar type="primary" [value]="level.completion" height="20px"></ngb-progressbar>
              </div>
              <div class="d-inline-block w-25 text-center">{{ level.completion }}%</div>
            </div>
          </div>
        </ng-container>
      </div>


      <div class="row">
        <div class="col-6">
          <p class="color-tertiary title-xs mar-b-1">{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + '.AREASCORE' | translate }}</p>
          <div id="chart" *ngIf="test.result.completionPercentage > 0">
            <p>{{ 'REPORT.CT.' + test.testModel.id + '.' + reportType.toUpperCase() + (reportType === 'candidate' ? '.SUCCESSPERCENTAGE' : '.SUCCESSPERCENTAGEANDTIME') | translate }}</p>
            <small *ngIf="reportType != 'candidate'">{{ 'REPORT.CT.COMMON.PERQUESTIONLEGEND' | translate }}</small>
            <div id="radarChart">
              <canvas baseChart
                [data]="radarChartData"
                [options]="radarChartOptions"
                type="radar"
                style="max-width: 400px; max-height: 350px;">
              </canvas>
            </div>
          </div>
          <div *ngIf="test.result.completionPercentage === 0">
            <div>{{ 'COMMON.NOTENOUGHTDATA' | translate }}</div>
          </div>
        </div>
        <div id="results" class="col-6">
          <p class="color-tertiary title-xs mar-b-1">{{ 'REPORT.EVALUALIA.RESULTSREPORT' | translate }}</p>
          <div *ngIf="test.result.completionPercentage> 0">
            <p [innerHtml]="this.areaResultExplanation"></p>
          </div>
          <div *ngIf="test.result.completionPercentage === 0">
            <div>{{ 'COMMON.NOTENOUGHTDATA' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Pagina final -->
    <ct-last-page-report [colors]="colors" [test]="test"></ct-last-page-report>
  </div>
</div>

<button class="btn btn-primary pdf_button" (click)="print()">{{ 'COMMON.GENERATEPDF' | translate }}</button>

<pre id="base64" hidden></pre>
